import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui';
import '@/styles/element-variables.scss'
// import 'element-ui/lib/theme-chalk/index.css';
// 引入reset.css文件
import '@/assets/CSS/reset.css';
// 时间格式转换
import moment from 'moment/moment'
import VueI18n from "vue-i18n";
import Cookies from 'js-cookie'




// 自定义展示文字通用二次确认框
/**
 *
 * @param {* 弹框主标题} title
 * @param {* 弹框主内容} content
 * @param {* 是否展示订单号 以及订单数量订单号} isShowOrder
 * @param {* 订单号或者订单数量文字} orderTitle
 * @param {* 具体的订单号以及订单数量} orderDetail
 * @param {* 回调函数} callback
 *
 */
Vue.prototype.confirmPopBox=function({title='',content='',isShowOrder=false,orderTitle='',orderDetail='',callback=()=>{},cancelCallback=()=>{}}){
  const h = this.$createElement;
  this.$msgbox({
    message: h('div', null, [
      h('div', {
        class:'custom_confirmation_box-title'
      }, title),
      h('i',{
        class:'el-icon-close',
        on:{
          click: () => {
            this.$msgbox.close();
          },
        }
      }),
      isShowOrder ? h('div',{
        class:'custom_confirmation_content-item'
      },[
        h('span',{},`${orderTitle}: `),
        h('span',{},orderDetail),
      ]) :'',
      h('div',{
        class:'custom_confirmation_content-item'
      },content)
    ]),
    showCancelButton: true,
    confirmButtonText: this.$t('common.btn_confirm'),
    cancelButtonText: this.$t('common.btn_cancel'),
    customClass:'custom_confirmation_box_function',
    type:'warning',
    beforeClose: (action, instance, done) => {
      if (action === 'confirm') {
        callback()
        done()
      } else {
        done();
        cancelCallback()
      }

    }
  })


}

// 导出
import localeMessage from "@/locale";

Vue.use(VueI18n)
Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.filter('moment', function (value, formatString){
  formatString = formatString || "YYYY-MM-DD";
  return moment(value).format(formatString)
})

export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage) return chooseLanguage
  // if has not choose language
  const language = (
      navigator.language || navigator.browserLanguage
  ).toLowerCase()
  const locales = Object.keys(localeMessage)
  for (const locale of locales) {
    if (language.indexOf(locale) > -1) {
      return locale
    }
  }
  return 'zh'
}

// window.addEventListener('beforeunload', (e) => {
//   window.sessionStorage.removeItem('userInfo')
// })

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: getLanguage(), // set locale
  messages: localeMessage, // set locale messages
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
